import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment';
import orderBy from 'lodash/orderBy';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { applyPhoneMask } from '@/utils/number';
import { formatSecToTime } from '@/utils/datetime';
import {
    UserDeviceStatus,
    UserQueueStatus,
    UserExtensionQuality,
    RealtimeReportServiceGetUserDevicesResult,
} from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDevicesTable',
  props: {
    userDevices: { type: Array, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const { t } = useI18n();

const props = __props;

const pingToQuality = (ping: number | null | undefined): UserExtensionQuality => {
    if (typeof ping !== 'number' || ping < 1) return UserExtensionQuality.UNAVAILABLE;
    if (ping > 205) return UserExtensionQuality.LOW;
    if (ping > 150) return UserExtensionQuality.MEDIUM;
    return UserExtensionQuality.HIGH;
};

const getCallDuration = (callCreationTime: Date | null | undefined): string => {
    if (!callCreationTime) return '';
    const seconds = moment.duration(moment().diff(moment(callCreationTime))).asSeconds();
    return formatSecToTime(seconds);
};
const computedUserDevices = computed(() => {
    const sorted = orderBy(
        props.userDevices,
        [
            (ud) => ud.user.extension?.number || '',
            (ud) => ud.user.name || '',
            (ud) => ud.deviceType || '',
        ],
        ['asc', 'asc', 'asc'],
    );

    return sorted.map((ud) => ({
        key: `${ud.user.id}_${ud.deviceType}`,
        extension: ud.user.extension?.number || '',
        name: ud.user.name || '',
        deviceTypeLabel: t(`core.device.${ud.deviceType}`),
        statusLabel: t(
            `report.realtime.device.status.${ud.state?.status || UserDeviceStatus.OFFLINE}`,
        ),
        statusClass:
            !ud.state?.status || ud.state.status === UserDeviceStatus.OFFLINE
                ? 'bg-danger-100 text-danger-700'
                : 'bg-success-50 text-success-700',
        queueStatusLabel: t(
            `report.realtime.user.queueStatus.${ud.user?.queueStatusHistory?.length ? UserQueueStatus.PAUSED : UserQueueStatus.UNPAUSED}`,
        ),
        queueStatusClass: ud.user?.queueStatusHistory?.length
            ? 'bg-danger-100 text-danger-700'
            : 'bg-success-50 text-success-700',
        phoneNumber: ud.state?.phoneNumber ? applyPhoneMask(ud.state.phoneNumber) : '',
        qualityLabel: t(`report.realtime.device.quality.${pingToQuality(ud.state?.ping)}`),
        callTypeLabel: ud.state?.callType ? t(`call.type.${ud.state.callType}`) : '',
        duration: getCallDuration(ud.state?.callCreationTime),
    }));
});

const __returned__ = { t, props, pingToQuality, getCallDuration, computedUserDevices }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})